export default __webpack_public_path__ + "static/media/klarnanew.bf04f697.png";